import React from 'react';

import clsx from 'clsx';

import styles from './styles.module.css';

type Props = React.HTMLAttributes<HTMLIFrameElement> & {
  videoId: string;
};

export function YouTubeVideoIframe({ videoId, className, ...rest }: Props) {
  return (
    <iframe
      {...rest}
      className={clsx(styles.iframe, className)}
      src={`https://www.youtube.com/embed/${videoId}`}
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    />
  );
}
